import { BaseModel } from "../base.model";

export class VariantDeliveryMethod extends BaseModel {
  isOnline!: number;
}
